import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/geounique/geounique/src/components/ui/BackButton.tsx");
